import React, { useEffect, useRef, useState } from 'react';
import { func, number, arrayOf, string } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Image } from '@thd-olt-component-react/core-ui';
import { LifeStyleDetails } from './LifeStyleDetails';
import {
  triggerAnalytics,
  iconUrl,
  imageStyle,
  removeActiveClass,
  toggleActiveClass
} from '../../helpers';
import './styles/hotspot.scss';

const LifeStyleHotspot = ({
  hsXPosition, hsYPosition, onClick, hotspotKey, omsIDs, imageUrl
}) => {
  const hotspotRef = useRef();
  const [imageSrc, setImageSrc] = useState(iconUrl);
  const [hotspotClicked, setClickHotspot] = useState(false);

  const hotspotClick = (event) => {
    setClickHotspot(true);
    onClick(event, hotspotRef.current);
    toggleActiveClass(event, '');
    const container = event?.currentTarget;
    const notSelected = container?.getAttribute('aria-expanded') === 'false';
    if (notSelected) {
      triggerAnalytics('product-hotspots.click');
    }
  };

  const removeActiveHotspotClass = (event) => {
    removeActiveClass(event, hotspotRef, onClick);
  };

  useEffect(() => {
    document.body.addEventListener('click', removeActiveHotspotClass);
    return () => {
      document.body.removeEventListener('click', removeActiveHotspotClass);
    };
  }, []);

  useEffect(() => {
    if (hotspotRef?.current?.className === 'tag') {
      setImageSrc(iconUrl);
    }
  }, [hotspotRef?.current?.className]);

  return (
    <div id={`tooltip-wrapper-div-${hotspotKey}`}>
      <Tooltip
        boundary="viewport"
        channel="desktop"
        content={hotspotClicked && (
          <LifeStyleDetails
            omsIDs={omsIDs}
            imageUrl={imageUrl}
          />
        )}
        closeButton
        showClose={false}
        interactive
        appendTo={() => document.querySelector(`#tooltip-wrapper-div-${hotspotKey}`)}
      >
        <button
          tabIndex="0"
          type="button"
          className="tag"
          data-testid="hotspot-container"
          id="hotspot-container"
          onClick={hotspotClick}
          ref={hotspotRef}
          style={imageStyle(hsXPosition, hsYPosition)}
        >
          <div />
          <Image
            tabIndex="-1"
            alt={`hotspot-${hotspotKey}`}
            className="icon"
            data-testid="hotspot"
            src={imageSrc}
            title=""
            width="25"
            height="25"
          />
        </button>
      </Tooltip>
    </div>
  );
};

LifeStyleHotspot.displayName = 'LifeStyleHotspot';

LifeStyleHotspot.propTypes = {
  hotspotKey: number,
  hsXPosition: string.isRequired,
  hsYPosition: string.isRequired,
  onClick: func.isRequired,
  imageUrl: string,
  omsIDs: arrayOf(string)
};

LifeStyleHotspot.defaultProps = {
  hotspotKey: 1,
  omsIDs: [],
  imageUrl: ''
};

LifeStyleHotspot.dataModel = extend(LifeStyleDetails);

export { LifeStyleHotspot };
